import { Box, BoxProps } from '@chakra-ui/react';
import { memo } from 'react';

export default memo(function SectionContents(props: BoxProps) {
  return <Box mt={6} {...props} />;
});
